import { render, staticRenderFns } from "./BindsFileIcon.vue?vue&type=template&id=264a2d9a&"
import script from "./BindsFileIcon.vue?vue&type=script&lang=js&"
export * from "./BindsFileIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports